import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    ratingGroup : [],
    loading : false,
    error : null,
};

const ratingGroupSlice = createSlice({
    name:"ratingGroup",
    initialState,
    reducers: {
        fetchratingGroupSuccess: (state,action) => {
            state.loading = false;
            state.ratingGroup = action.payload;
        },
        fetchratingGroupFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchratingGroupSuccess,
    fetchratingGroupFailure
} = ratingGroupSlice.actions

export default ratingGroupSlice.reducer